import { useNavigate, useParams } from 'react-router-dom';
import { CurriculumSubjectsTable } from '../../../../../components/Curricula/Tables/CurriculumSubjectsTable';

export const CurriculumSubjectsSubpage = () => {
  const navigate = useNavigate();
  const { curriculumUuid } = useParams();

  return (
    <CurriculumSubjectsTable curriculumUuid={curriculumUuid} onNavigate={(subjectUuid) => navigate(subjectUuid)} />
  );
};
